module.exports = __webpack_public_path__ + "static/media/iu_logo2.60ed0bd3.png";